import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Proposition.styles'

const PaymentPlan = ({ service, serviceIndex, onClick }) => {
  const serviceButton = (termsAndConditions, cta) => (
    <Styled.ServiceButton
      data-test={`m023-service-button-${serviceIndex}`}
      onClick={() => onClick('open', '', termsAndConditions)}
      kind='secondary'
    >
      {cta}
    </Styled.ServiceButton>
  )
  const {
    heading,
    subheading,
    ctaStyle,
    mainImage,
    aprMessage,
    smallCopy,
    termsAndConditions,
    isSmall,
    isValid
  } = service
  if (!isValid) return null
  if (isSmall) {
    return (
      <Styled.M023PropositionsCard
        onClick={() => onClick('open', '', termsAndConditions)}
        data-test={`m023-paymentPlan-container-${serviceIndex}`}
      >
        <Styled.PropositionsWrapper data-test='m023-paymentPlan-content-container'>
          <Styled.M023Image data-test='m023-paymentPlan-image' src={mainImage.source} alt={mainImage.altText} />
          <Styled.SmallCta data-test='m023-paymentPlan-text-container'>
            <strong data-test='m023-paymentPlan-heading'>{heading}</strong>
            <span data-test='m023-paymentPlan-ctaCopy'>{ctaStyle}</span>
          </Styled.SmallCta>
        </Styled.PropositionsWrapper>
      </Styled.M023PropositionsCard>
    )
  }
  return (
    <Styled.Wrapper row='xs' gutterValue={0} gutterSize='15px' data-test={`m023-paymentPlan-container-${serviceIndex}`}>
      <Styled.TextWrapper gutterValue={1} xs={7} md={7} data-test='m023-paymentPlan-text-wrapper' smallCopy={smallCopy}>
        <h4 data-test='m023-paymentPlan-heading'>{heading}</h4>
        {aprMessage && <h4 data-test='m023-paymentPlan-aprMessage'>{aprMessage}</h4>}
        {subheading && (
          <p data-test='m023-paymentPlan-subheading' style={{ margin: 0 }}>
            {subheading}
          </p>
        )}
        {smallCopy && <small data-test='m023-paymentPlan-smallCopy'>{smallCopy}</small>}
        <Styled.ButtonWrapperMd data-test='m023-paymentPlan-buttonMd-wrapper'>
          {serviceButton(termsAndConditions, ctaStyle)}
        </Styled.ButtonWrapperMd>
        <Styled.ButtonWrapperLg data-test='m023-paymentPlan-buttonLg-wrapper'>
          {serviceButton(termsAndConditions, ctaStyle)}
        </Styled.ButtonWrapperLg>
      </Styled.TextWrapper>
      <Styled.ImageWrapper gutterValue={1} gutterSize='30px' xs={5} md={5} data-test='m023-paymentPlan-image-wrapper'>
        <Styled.PropositionsImage data-test='m023-paymentPlan-image' src={mainImage.source} alt={mainImage.altText} />
      </Styled.ImageWrapper>
    </Styled.Wrapper>
  )
}

PaymentPlan.propTypes = {
  service: PropTypes.shape({
    isSmall: PropTypes.bool,
    isValid: PropTypes.bool,
    type: PropTypes.oneOf(['benefit', 'proposition', 'paymentPlan']),
    heading: PropTypes.string,
    aprMessage: PropTypes.string,
    subheading: PropTypes.string,
    smallCopy: PropTypes.string,
    ctaStyle: PropTypes.string,
    mainImage: PropTypes.shape({
      source: PropTypes.string.isRequired,
      altText: PropTypes.string.isRequired
    }),
    termsAndConditions: PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  }).isRequired,
  serviceIndex: PropTypes.number,
  onClick: PropTypes.func
}

PaymentPlan.defaultProps = {
  serviceIndex: 0,
  onClick: () => {}
}

export { PaymentPlan }
